<template>
  <div
    class="flex items-center gap-0 overflow-hidden rounded-r-corner-8 opacity-0 transition-opacity group-hover:opacity-100 group-[:focus-within]:opacity-100 focus:opacity-100 [&_a]:rounded-none [&_button]:rounded-none"
  >
    <slot />
  </div>
</template>
